<template>
    <div>
        <dx-grid
            url="ivrCalls"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></dx-grid>
        <v-dialog v-model="callActivityDialog" max-width="550">
            <v-card class="pa-2">
                <v-card-title class="headline">Call Activity</v-card-title>
                <v-card-text class="mb-3">
                    <v-layout row>
                        <div>
                            <div class="font-weight-medium mb-2">
                                {{ clickedCall.name }}
                            </div>
                            <div class="mb-2">{{ clickedCall.nameH }}</div>
                            <router-link
                                class="mb-2"
                                :to="{
                                    name: 'Account View',
                                    params: { id: clickedCall.accountID },
                                }"
                            >
                                <button>
                                    {{ clickedCall.accountID }}
                                </button></router-link
                            >
                        </div>
                        <v-spacer></v-spacer>
                        <div>
                            <v-layout row class="mb-2">
                                <div class="font-weight-medium mr-2">
                                    Call Time:
                                </div>
                                <div>
                                    {{ clickedCall.date }}
                                </div>
                            </v-layout>
                        </div>
                    </v-layout>
                </v-card-text>
                <v-list>
                    <div v-for="(action, index) in clickedCall.callActivity">
                        <v-list-tile
                            v-bind:class="{ 'action-tile': action.description }"
                        >
                            <v-list-tile-content>
                                <v-list-tile-title>{{
                                    action.date
                                }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-spacer></v-spacer>
                            <v-list-tile-action>
                                <v-list-tile-title class="text-xs-right"
                                    >{{ action.title }}
                                </v-list-tile-title>
                                <div class="text--disabled text-xs-right">
                                    {{ action.description }}
                                </div>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider
                            v-if="index + 1 < clickedCall.callActivity.length"
                        ></v-divider>
                    </div>
                </v-list>
                <v-card-actions class="mr-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="callActivityDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "IVR Calls",
        columns: [
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                format: "",
                template: "link-action-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "week")
                        .add(1, "day")
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "Caller ID",
                field: "callerID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Phone Line",
                field: "phoneLine",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        callActivityDialog: false,

        clickedCall: {
            name: "",
            nameH: "",
            accountID: "",
            date: "",
            activity: [],
        },

        callActionsMap: new Map([
            ["LOOKUP_PHONE", "Lookup callerID"],
            ["VALIDATE_PHONE", "Validate Phone"],
            ["VALIDATE_PIN", "Validate Pin / Load Account"],
            ["RECOVER_PIN", "Recover Pin"],
            ["VALIDATE_CARD", "Entered Credit Card"],
            ["VALIDATE_SAVED_CARD", "Validate Saved Card"],
            ["VALIDATE_EXP", "Validate Expiration Date"],
            ["PLAY_MISSING_IMMUNIZATIONS", "Play Missing Immunizations"],
            ["PLAY_REGISTRATION_STATUS", "Play Registration Status"],
            ["TUITION_BALANCE_DETAILS", "Play Tuition Balance Details"],
            [
                "TRANSPORTATION_BALANCE_DETAILS",
                "Play Transportation Balance Details",
            ],
            ["PLAY_SAVED_CARDS", "Play Saved Cards List"],
            ["PAYMENT_PLAN_DETAILS", "Play Payment Plan Details"],
            ["START_PAYMENT_PROCESS", "Start Payment Process"],
            ["START_AUTOPAYSETUP_PROCESS", "Start Auto Pay Setup Process"],
            ["PAYMENT_PROCESSING", "Payment Procssing"],
            ["CARD_PROCESSED_SUCCESS", "Payment Processed Successfully"],
            ["CARD_PROCESSED_FAILED", "Payment Failed"],
            ["AUTOPAY_SETUP_FAILED", "Auto Pay Setup Failed"],
            ["AUTOPAY_SETUP_SUCCESS", "Auto Pay Setup Successfull"],
            ["CONTACT_US", "Contact Us"],
            ["HANGUP", "Hangup"],
        ]),
    }),
    created() {
        this.columns.find(
            (c) => c.field == "accountID"
        ).linkAction = this.onAccountIDClicked;
    },
    methods: {
        onAccountIDClicked(row) {
            this.$router.push({
                name: "Account View",
                params: {
                    id: row.accountID,
                },
                query: {
                    goToIvrCallSection: true,
                },
            });
        },
        async onRowClicked(call) {
            this.clickedCall.date = moment(call.date).format("LLL");
            this.clickedCall.accountID = call.accountID;
            this.clickedCall.name = call.name;
            this.clickedCall.nameH = call.nameH;

            const callActivity = await this.$http.get(
                "api/broadcast/getCallActivity?callUUID=" + call.call_UUID
            );

            this.clickedCall.callActivity = callActivity.map((action) => {
                action.date = moment(action.date).format("LTS");
                action.title =
                    this.callActionsMap.get(action.eventType) ||
                    action.eventType;
                action.description = this.getActionDescription(action);

                return action;
            });

            this.callActivityDialog = true;
        },
        getActionDescription(action) {
            if (
                [
                    "START_PAYMENT_PROCESS",
                    "START_AUTOPAYSETUP_PROCESS",
                ].includes(action.eventType)
            )
                return null;

            const inputActions = [
                "LOOKUP_PHONE",
                "VALIDATE_PHONE",
                "VALIDATE_PIN",
                "VALIDATE_CARD",
                "VALIDATE_EXP",
                "VALIDATE_SAVED_CARD",
            ];

            if (inputActions.includes(action.eventType)) {
                return action.inputDigits + " | " + action.response;
            }

            if (action.eventType == "CARD_PROCESSED_SUCCESS") {
                const pecies = action.response.split("|");
                const status = pecies
                    .find((p) => p.startsWith("status"))
                    .substring(7);
                const amount = pecies
                    .find((p) => p.startsWith("amount"))
                    .substring(7);

                return "$" + amount + " | " + status;
            }

            return action.inputDigits + " | " + action.response;
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.action-tile .v-list__tile {
    height: 65px;
}
</style>
